<script>
  import Input from '@ui/pico/input.svelte';

  import { editForm as editFormSvc, getForm } from '../../services';
  import { goto } from '../../util';
  import { pages, redirectors } from '../../config';
  import { account, ux } from '../../store';

  export let params;
  let form;
  let sid;

  $: fid = params?.fid;
  $: editForm = {
    fid,
    formLinkCode: '',
    name: '',
  };

  $: {
    if ($account && !form) {
      init();
    }
  }

  async function init() {
    form = await getForm({ fid });
    sid = form?.sid;

    editForm.sid = sid;
    editForm.fid = fid;
    editForm.name = form.name;
    editForm.formLinkCode = form.formLinkCode;
  }

  function handleRedirect(from, data = {}) {
    const exists = redirectors[from];
    let params = null;
    if (exists && exists.params) {
      params = exists.params.map((paramName) => data[paramName]);
      goto(exists.target, ...params);
    }
    return !!exists;
  }
  function onCancel() {
    if (!handleRedirect(params.from, { sid })) {
      goto(pages.account.overview.url);
    }
  }
  async function onConfirm() {
    const res = await editFormSvc(editForm);

    $ux.formDeletionResponse = res;
    if (!handleRedirect(params.from, { sid })) {
      goto(pages.sites.overview.url, sid);
    }
  }
</script>

<form on:submit|preventDefault={onConfirm}>
  <dialog open>
    <article>
      <h3>Edit Form</h3>
      <Input type="text" bind:value={editForm.name} name="name" label="Name" />
      <Input
        type="text"
        bind:value={editForm.formLinkCode}
        name="formLinkCode"
        label="Form Link Code"
      />
      <footer>
        <button type="button" class="secondary" on:click={onCancel}>
          Cancel
        </button>
        <button type="submit">Update</button>
      </footer>
    </article>
  </dialog>
</form>

<style>
  article {
    width: 60vw;
    max-width: 900px;
  }
</style>
